module.exports = __webpack_public_path__ + "static/media/Hero_Image_Mobile_7.be90a1ab.jpg";